import { render, staticRenderFns } from "./FloatingAlert.vue?vue&type=template&id=24b7f4f5&scoped=true&"
import script from "./FloatingAlert.vue?vue&type=script&lang=ts&"
export * from "./FloatingAlert.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingAlert.vue?vue&type=style&index=0&id=24b7f4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7f4f5",
  null
  
)

export default component.exports